export default function PandemicPlanDirective() {
  return {
    template: require('./pandemic-plan.html'),
    scope: {
      assessmentId: '=',
      status: '=',
      canEdit: '<',
    },
    controller: 'PandemicPlanController',
    controllerAs: 'pandemicPlanVM',
    bindToController: true,
    replace: true,
  };
}
